import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getMiscs,
  createMisc,
  updateMisc,
  deleteMisc
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import {
  showSuccessToastMessage,
  showErrorToastMessage
} from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
// import Search from "../Common/Search";
import AdminBreadcrumb from "../Common/Breadcrumb";
import { emptyCheck } from "../../../../utilities";
import RequiredField from "../Common/RequiredField";

class AdminTranslation extends Component {
  state = {
    mastermiscs: [],
    miscs: [],
    selectedMisc: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: ""
  };
  componentDidMount() {
    this.getMiscsFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  getMiscsFromService() {
    this.showSpinner(true);
    getMiscs()
      .then(response => {
        this.setState({ miscs: response.data, mastermiscs: response.data });
        this.showSpinner(false);
      })
      .catch(error => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
      });
  }

  editMisc(misc) {
    this.setState({
      action: "edit",
      selectedMisc: misc,
      showModal: true,
      errorMessage: ""
    });
  }

  deleteMisc(misc) {
    this.setState({
      action: "delete",
      selectedMisc: misc,
      showDeleteModal: true
    });
  }

  addMisc() {
    this.setState({
      action: "add",
      selectedMisc: {},
      showModal: true,
      errorMessage: ""
    });
  }
  onHideModal() {
    this.setState({
      showModal: false
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Misc");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  validate(data) {
    if (emptyCheck(data.Text)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }
  saveMisc() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedMisc.Id : 0,
      Key: this.refs["txtKey"].value,
      Text: this.refs["txtText"].value,
      TId: this.state.action === "edit" ? this.state.selectedMisc.TId : 0
    };

    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createMisc(data)
            .then(response => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Key);
              this.getMiscsFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateMisc(data)
            .then(response => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Key);
              this.getMiscsFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteMisc() {
    this.showSpinner(true);
    deleteMisc(this.state.selectedMisc.Id)
      .then(response => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedMisc.Key);
        this.getMiscsFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        // console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleMiscChange = event => {
    let selectedMisc = this.state.selectedMisc;
    selectedMisc.Name = event.target.value;
    this.setState({ selectedMisc: selectedMisc });
  };

  manageJobRoles(misc) {
    this.props.history.push(`/admin/jobroles/` + misc.Id);
  }

  handleSearchTermChange = event => {
    let filteredMiscs = this.state.mastermiscs.filter(d => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        miscs: filteredMiscs,
        searchTerm: event.target.value
      });
    else
      this.setState({
        miscs: this.state.mastermiscs,
        searchTerm: event.target.value
      });
  };

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">Translations</h1>
        <AdminBreadcrumb
          data={[
            { name: "Home", link: "/admin/modules/" },
            { name: "Translations" }
          ]}
        />
        {/* <button className="btn btn-default add-btn" onClick={() => this.addMisc()}>
          Add Translation
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} /> */}
        <Grid
          headers={["#", "Key", "Text"]}
          values={this.state.miscs}
          indexName="Id"
          properties={["Id", "Key", "Text", "Action"]}
          edit={value => this.editMisc(value)}
          delete={value => this.deleteMisc(value)}
          hideDelete
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveMisc()}
          form={this.addeditform}
          type="Translation"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>Key:</label>
            <input
              maxLength="50"
              type="text"
              disabled="disabled"
              className="form-control"
              ref="txtKey"
              defaultValue={this.state.selectedMisc.Key}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Text:
            </label>
            <textarea
              className="form-control"
              ref="txtText"
              defaultValue={this.state.selectedMisc.Text}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedMisc.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteMisc()}
          name={this.state.selectedMisc.Key}
          type="Translation"
        />
      </Aux>
    );
  }
}

export default AdminTranslation;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Translation/Translation.js